import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getDeviceDefaultConfigFile } from '../../services/DeviceService';
import { DeviceDefaultConfigFile } from '../../types/Devices';

/**
 * The defaults that apply to one device — the config file uploaded for its HW model and FW
 * version, which is what "Reset to Default" writes back.
 *
 * Unlike useGetDeviceDefaultConfiguration this is per device, so it is keyed by device and only
 * cached for the session: a new file can be uploaded, or the device can report a new firmware,
 * without the portal reloading.
 */
function useGetDeviceDefaultConfigFile(
  deviceId: string,
  fleetId: string,
): UseQueryResult<DeviceDefaultConfigFile> {
  return useQuery(
    ['device-default-config-file', fleetId, deviceId],
    async (): Promise<DeviceDefaultConfigFile> => getDeviceDefaultConfigFile(fleetId, deviceId),
    {
      enabled: !!deviceId && !!fleetId,
      retry: 1,
      retryDelay: 3000,
      refetchOnWindowFocus: false,
    },
  );
}

export default useGetDeviceDefaultConfigFile;
